import {TweenMax} from "gsap";


module.exports = function (app) {
  app.registerComponent('welcome-overlay', '.js-welcome-overlay', function (sb, el) {

    var hideOverlayEl = el.querySelector('.js-hide-overlay');
    var overlayVisible = true;
    var scrollPosTrigger = 20;
    var hideOverlay = function() {
      el.classList.remove('is-visible')
            overlayVisible = false;
    }
    var onWindowScroll = function(scroll) {
      if(scroll.scrollPos > scrollPosTrigger) hideOverlay()
    }

    /* INIT ------------------------------------------- */
    return {
      init: function () {

        onWindowScroll({scrollPos:document.body.scrollTop})
        sb.subscribe('window/scroll', onWindowScroll)
        hideOverlayEl.addEventListener('click', hideOverlay)
      },
      destroy: function () {
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/welcome-overlay.js